module.exports = "//static.hsappstatic.net/signup-ui-lego/static-1.9882/images/long-brown-hair-red/long-brown-hair-red@3x.png"